import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import {
    CalendarModule,
    DateInputModule,
    DatePickerModule,
    DateRangeModule,
    DateTimePickerModule,
    MultiViewCalendarModule,
    TimePickerModule,
} from '@progress/kendo-angular-dateinputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

import { KendoCheckboxComponent } from './kendo-controls/kendo-checkbox/kendo-checkbox.component';
import { KendoLoadingComponent } from './kendo-controls/kendo-loading/kendo-loading.component';
import { AfterValueChangedDirective } from './kendo-controls/after-value-changed.directive';
import {
    KendoDateInputExtraDirective,
    KendoDatePickerExtraDirective,
    KendoDateTimePickerExtraDirective,
    KendoTimePickerExtraDirective,
    KendoTextBoxExtraDirective,
    KendoComboBoxExtraDirective,
    TooltipExtraDirective,
    KendoTextAreaExtraDirective,
    KendoDropDownListDisabledDirective,
    KendoTilelayoutItemExtraDirective,
    KendoButtonExtraDirective,
    KendoGridExtraDirective,
    KendoDialogExtraDirective
} from './kendo-controls-extra.directive';
import { KendoDateTimeRangeComponent } from './kendo-controls/kendo-datetime-range/kendo-datetime-range.component';
import { KendoCustomDatePickerAMPMComponent } from './kendo-controls/kendo-custom-date-picker-ampm/kendo-custom-date-picker-ampm.component';
import { InputAfterValueChangedDirective } from './kendo-controls/input-after-value-changed.directive';
import { InvClassDirective } from './directives/inv-class.directive';
import { KendoTextIconComponent } from './kendo-controls';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { DistanceConversionPipe } from './pipes';

@NgModule({
    imports: [
        MatIconModule,
        LabelModule,
        DropDownsModule,
        CommonModule,
        FormsModule,
        GridModule,
        DateInputModule,
        CalendarModule,
        DatePickerModule,
        DateRangeModule,
        DateTimePickerModule,
        MultiViewCalendarModule,
        TimePickerModule
    ],
    declarations: [
        KendoDateInputExtraDirective,
        KendoDatePickerExtraDirective,
        KendoDateTimePickerExtraDirective,
        KendoTimePickerExtraDirective,
        KendoTextBoxExtraDirective,
        KendoTextAreaExtraDirective,
        KendoComboBoxExtraDirective,
        KendoTilelayoutItemExtraDirective,
        TooltipExtraDirective,
        KendoDropDownListDisabledDirective,
        KendoCheckboxComponent,
        KendoLoadingComponent,
        AfterValueChangedDirective,
        InputAfterValueChangedDirective,
        KendoDateTimeRangeComponent,
        KendoCustomDatePickerAMPMComponent,
        InvClassDirective,
        KendoButtonExtraDirective,
        KendoGridExtraDirective,
        KendoTextIconComponent,
        DistanceConversionPipe,
        KendoDialogExtraDirective
    ],
    exports: [
        KendoDateInputExtraDirective,
        KendoDatePickerExtraDirective,
        KendoDateTimePickerExtraDirective,
        KendoTimePickerExtraDirective,
        KendoTextBoxExtraDirective,
        KendoTextAreaExtraDirective,
        KendoComboBoxExtraDirective,
        KendoTilelayoutItemExtraDirective,
        TooltipExtraDirective,
        KendoDropDownListDisabledDirective,
        KendoCheckboxComponent,
        KendoLoadingComponent,
        AfterValueChangedDirective,
        InputAfterValueChangedDirective,
        KendoCheckboxComponent,
        KendoDateTimeRangeComponent,
        KendoCustomDatePickerAMPMComponent,
        InvClassDirective,
        KendoButtonExtraDirective,
        KendoGridExtraDirective,
        KendoTextIconComponent,
        DistanceConversionPipe,
        KendoDialogExtraDirective
    ],
    providers: [
        DateInputModule,
        TooltipDirective,
        {
            provide: ICON_SETTINGS,
            useValue: { type: 'font' },
        },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ControlsModule {}
